// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"480":"c6feb5ac","711":"ab4c6244","878":"c9db1fd0"}[chunkId] + ".chunk.css";
};